<template>
    <div>
        <h4>{{ $t('inventory_stock_out_temp') }}</h4>
        <div v-if="isLoading">
            <hr>
            <div class="spinner-border" role="status">
                <span class="visually-hidden">{{ $t('common_loading') }}</span>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-md-3">
                <button class="btn btn-primary" @click="selectDelete">{{ $t('common_delete') }}</button>
            </div>
            <div class="col-md-3">
                <span v-if="selectedRowsNum > 0">{{ $t('common_row_selected') }} {{selectedRowsNum}}</span>
            </div>
            <div class="col-md-3">
                <div class="row">
                    <div class="col-md-6">
                        <button class="btn btn-primary" @click="selectDriver">{{ $t('inventory_stock_out_driver') }}</button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-primary" @click="selectDep">{{ $t('inventory_stock_out_department') }}</button>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="row">
                    <div class="col-md-12">
                        <button class="btn btn-primary" @click="selectConfirm">
                            {{ $t('common_confirm') }}
                        </button>
                    </div>
<!--                    <div class="col-md-6">-->
<!--                        <button class="btn btn-primary" @click="selectPreview">-->
<!--                            Preview-->
<!--                        </button>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
        <hr>
        <div ref="tabulatorTableUse"></div>
        <div class="row">
            <div class="col-md-6"><button class="btn btn-success" style="width: 80%" @click="deselectAll">{{ $t('common_row_unselect_all') }}</button></div>
            <div class="col-md-6"><button class="btn btn-success" style="width: 80%" @click="selectAll">{{ $t('common_row_select_all') }}</button></div>
        </div>
    </div>
</template>

<script>
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "StockOutTempListBox",
    data(){
        return{
            isLoading: true,
            selectedRowsNum: 0,
            departmentList: [],
            driverList: [],
        }
    },
    methods: {
        async getBackendData(){
            this.isLoading = true
            await this.$mainApi.get('api/inventory/stock-out-temp/')
                .then(response => {
                    if(response.data.status === 80){
                        this.tabulator.setData(response.data.details)
                    }
                })
            await this.$mainApi.get('api/other-details/processor?type=department')
                .then(response => {
                    if(response.data.status === 80){
                        let data = response.data.details.returnData
                        this.departmentList = []
                        for(let i=0;i<data.length;i++){
                            if(data[i]['flag'] === 1){
                                this.departmentList.push(data[i]['name'])
                            }
                        }
                    }
                })
            await this.$mainApi.get('api/other-details/processor?type=driver')
                .then(response => {
                    if(response.data.status === 80){
                        let data = response.data.details.returnData
                        this.driverList = []
                        for(let i=0;i<data.length;i++){
                            if(data[i]['flag'] === 1){
                                this.driverList.push({
                                    "label": data[i]['name'] + ' (' + data[i]['phone'] + ')',
                                    "value": data[i]['id']
                                })
                            }
                        }
                    }
                })
            this.isLoading = false
        },
        async selectDelete(){
            this.$swal.fire({
                title: 'confirm?',
                icon: 'info'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.isLoading = true
                    for(let i of this.tabulator.getSelectedData()){
                        await this.$mainApi.delete(`api/inventory/stock-out-temp?id=${i.id}`)
                            .then(response => {
                                // pass
                            })
                    }
                    this.isLoading = false

                    this.$toast.success(this.$t('common_success'))
                    await this.getBackendData()
                }
            })
        },
        inputHtmlCreator(mode){
            let html = ``
            if(mode === 'department'){
                html = `
                        <input type="text" list="dataList" id="swal-input"
                        class="swal2-input" placeholder="department..."/>
                        <datalist id="dataList">
                        `
                for(let i of this.departmentList){
                    html += `<option>${i}</option>`
                }
                html += `</datalist>`
            }
            if(mode === 'driver'){
                html = `<select id="swal-select" class="swal2-select">`
                for(let i=0;i<this.driverList.length;i++){
                    html += `<option value="${this.driverList[i].value}" selected>${this.driverList[i].label}</option>`
                }
                html += `</select>`
            }
            return html
        },
        async selectDriver(){
            this.isLoading = true
            this.$swal.fire({
                title: 'update data',
                html: this.inputHtmlCreator('driver'),
                showCancelButton: true,
                confirmButtonText: this.$t('common_update'),
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return new Promise(async (resolve) => {
                        await this.$mainApi.put('api/inventory/stock-out-temp-multi/', {
                            "mode": 'driver',
                            "data": this.tabulator.getSelectedData().map(a => a.id),
                            "driverID": document.getElementById('swal-select').value,
                        })
                            .then(response => {
                                resolve(response.data)
                            })
                    })
                },
                allowOutsideClick: () => !this.$swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value.status === 80){
                        this.$swal.fire({
                            title: this.$t('common_success'),
                            icon: 'success'
                        })
                        this.getBackendData()
                    }else{
                        this.$swal.fire({
                            title: result.value.errors,
                            text: JSON.stringify(result.value.details),
                            icon: 'error'
                        })
                    }
                }
            })
            this.isLoading = false
        },
        async selectDep(){
            this.isLoading = true
            this.$swal.fire({
                title: 'update data',
                html: this.inputHtmlCreator('department'),
                inputValidator: (inputValue) => {
                    return new Promise((resolve) => {
                        if (inputValue) {
                            resolve()
                        } else {
                            resolve(this.$t('stock_take_main_name_required'))
                        }
                    })
                },
                showCancelButton: true,
                confirmButtonText: this.$t('common_update'),
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return new Promise(async (resolve) => {
                        // Validate input
                        if (!document.getElementById('swal-input').value) {
                            resolve(this.$t('stock_take_main_name_required'))
                        } else {
                            this.$swal.resetValidationMessage(); // Reset the validation message.
                            await this.$mainApi.put('api/inventory/stock-out-temp-multi/', {
                                "mode": 'department',
                                "data": this.tabulator.getSelectedData().map(a => a.id),
                                "department": document.getElementById('swal-input').value,
                            })
                                .then(response => {
                                    resolve(response.data)
                                })
                                .catch(error => {
                                    this.$swal.showValidationMessage(
                                        `Request failed: ${error}`
                                    )
                                })
                        }
                    })
                },
                allowOutsideClick: () => !this.$swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value.status === 80){
                        this.$swal.fire({
                            title: this.$t('common_success'),
                            icon: 'success'
                        })
                        this.getBackendData()
                    }else{
                        this.$swal.fire({
                            title: result.value.errors,
                            text: JSON.stringify(result.value.details),
                            icon: 'error'
                        })
                    }
                }
            })
            this.isLoading = false
        },
        async selectPreview(){
            this.isLoading = true
            /*await this.$mainApi.post('api/inventory/stock-out-temp-multi/', {
                "mode": 'preview',
                "data": this.tabulator.getSelectedData().map(a => a.id),
            })
                .then(response => {
                    if(response.data.status === 80){
                        for(let i of response.data.details){
                            window.open(this.$store.state.serverIp + i)
                            // location.href = (this.$store.state.serverIp + i)
                        }
                    }if(response.data.status === 10){
                        this.$swal.fire({
                            title: "error",
                            text: response.data.details,
                            icon: "warning"
                        })
                    }
                })*/
            this.isLoading = false
        },
        async selectConfirm(){
            if(this.tabulator.getSelectedData().length === 0){
                this.$swal.fire({
                    title: 'Please select a item',
                    icon: 'error'
                })
            }else{
                this.isLoading = true
                this.$swal.fire({
                    title: 'confirm ?',
                    icon: 'info'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await this.$mainApi.post('api/inventory/stock-out-temp-multi/', {
                            "mode": 'confirm',
                            "data": this.tabulator.getSelectedData().map(a => a.id),
                        })
                            .then(response => {
                                console.log(response.data)
                                if(response.data.status === 80){
                                    for(let i of response.data.details){
                                        window.open(this.$store.state.serverIp + i)
                                        // location.href = (this.$store.state.serverIp + i)
                                    }
                                }if(response.data.status === 0){
                                    let html = ''
                                    let data = response.data.details
                                    for(let i=0;i<data.length;i++){
                                        html += `
                            <div style="border: black solid 1px">
                            <h4>${data[i]['dn_name']}<span style="font-size: 10px">(ID: ${data[i]['dn_id']})</span></h4>
                            `
                                        if(data[i].errors === 'common'){
                                            for(let ii of data[i].details){
                                                html += `
                                    <div class="row">
                                        <div class="col-md-3">${ii.outCode}</div>
                                        <div class="col-md-3">${ii.location}</div>
                                        <div class="col-md-3">${ii.errors}</div>
                                        <div class="col-md-3">${JSON.stringify(ii.details)}</div>
                                    </div>
                                    `
                                            }
                                        }else{
                                            html += `
                                <div class="row">
                                    <div class="col">${data[i].details}</div>
                                </div>
                                `
                                        }
                                        html += `</div><hr>`
                                    }
                                    this.$swal.fire({
                                        title: "error",
                                        html: html,
                                        icon: "warning"
                                    })
                                }if(response.data.status === 10){
                                    this.$swal.fire({
                                        title: "error",
                                        text: response.data.details,
                                        icon: "warning"
                                    })
                                }

                                this.getBackendData()
                            })
                    }
                })
                this.isLoading = false
            }
        },
        selectAll(){
            this.tabulator.selectRow()
        },
        deselectAll(){
            this.tabulator.deselectRow()
        }
    },
    mounted() {
        this.getBackendData()

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {title: "id", field: 'id', resizable: false, sorter: 'number', width: 10, responsive: 0,},
                {
                    title: this.$t('inventory_stock_out_dn'), field: 'dn', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 250, formatter: 'textarea',
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('inventory_stock_out_date'), field: 'stockOutDate', sorter: 'string', resizable: false,
                    formatter: 'textarea',
                    responsive: 1, minWidth: 80,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('inventory_stock_in_remarks'), field: 'remarks', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 80,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('inventory_stock_out_dn_inside_records'), field: 'count_record', sorter: 'number', resizable: false,
                    responsive: 1, maxWidth: 80, hozAlign: 'center',
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('inventory_stock_out_department'), field: 'department', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 80,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('inventory_stock_out_driver'), field: 'driver', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 100, formatter: 'textarea',
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('user_show_name'), field: 'show_name', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 100,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_create_date'), field: 'createDate', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 100,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-plus-circle-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        this.$swal.fire({
                            text: this.$t('common_confirm') + this.$t('inventory_stock_out_temp_list') + ' ?',
                            icon: 'info'
                        }).then(async result => {
                            if (result.isConfirmed) {
                                // get selected Data
                                await this.$mainApi.get(`api/inventory/stock-out-temp-each?sid=${row.getData().id}`)
                                    .then(response => {
                                        if(response.data.status === 80){
                                            let returnData = {
                                                "sid": row.getData().id,
                                                "dn": row.getData().dn,
                                                "details": response.data.details
                                            }
                                            this.$emit('clickedOnTemp', returnData)
                                        }
                                    })
                            }
                        })
                    }
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-trash-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        this.$swal.fire({
                            title: this.$t('common_confirm_action_delete'),
                            icon: 'warning'
                        }).then(async result => {
                            if (result.isConfirmed) {
                                // delete
                                await this.$mainApi.delete(`api/inventory/stock-out-temp?id=${row.getData().id}`)
                                    .then(response => {
                                        if(response.data.status === 80){
                                            this.$toast.success(this.$t('common_success'))
                                            this.getBackendData()
                                        }
                                    })
                            }
                        })
                    }
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '40vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            selectable: true,
            selectableRangeMode:"click",
        })
        this.tabulator.on('rowSelectionChanged', (data, rows) => {
            this.selectedRowsNum = rows.length
        })
    }
}
</script>

<style scoped>

</style>
